import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cellLength'
})
export class CellLengthPipe implements PipeTransform {

  transform(value: string, exponent: number): string {
    if (value == null)
      return "";
    if (value.length > exponent) {
      var str = value.slice(0, exponent);
      return str + "...";
    } else
      return value;
  }
}
